<template>
    <control-wrapper
        v-bind="controlWrapper"
        :styles="styles"
        :isFocused="isFocused"
        :appliedOptions="appliedOptions"
    >
      <el-cascader
          v-model="value"
          :props="{ checkStrictly: true }"
          :options="options"
          :filterable="appliedOptions.filterable"
          :show-all-levels="false"
          :disabled="!control.enabled"
          :clearable="!config.required"
          :autofocus="appliedOptions.focus" 
          :placeholder="appliedOptions.placeholder" size="mini"
          @change="handleChange"></el-cascader>
    </control-wrapper>
  </template>

  <script>
  import {formatIs, rankWith} from '@jsonforms/core';
  import { rendererProps, useJsonFormsControl } from '@jsonforms/vue2';
  import { useVanillaControl, ControlWrapper } from '@jsonforms/vue2-vanilla';
  import { defineComponent, ref } from 'vue';

  import apiAxios from "@/config/apiAxios";
  const controlRenderer = defineComponent( {
    name: "industry",
    setup(props) {
      return useVanillaControl(useJsonFormsControl(props), target => {
        return target.value || undefined
      });
    },
    //schema, uischema, path, enabled, renders, cells, config
    props     : {
      ...rendererProps()
    },
    components: { ControlWrapper },
    data(){
      return {
        value       : "",
        options     : []
      }
    },
    methods : {
      handleChange( _rst ){
        this.value  = _rst?.pop() || "";
        this.onChange( {
          "target" : { "value" : this.value }
        } )
      }
    },
    created() {
      //this.control 当前对象
      /*获取国民经济分类*/
      apiAxios.get( `${config.serverUrl}/cmcf/v1/thdb/subject/category/FL00000003`, {}, _r => {
        if( _r?.code == 200 && _r?.data ){
          this.options  = _r.data.children;
         // sessionStorage.setItem('INDUSTRY_CONFIG_JSON_VAL', JSON.stringify(_r.data.children))
        }

        //this.control 当前对象
        if( this.control.data ){
          this.value  = this.control.data;
        }
      } )
    }
  } );


  export default controlRenderer;

  export const entry = {
    renderer: controlRenderer,
    tester: rankWith(10, formatIs( "zysl-industry" ) )
  };
  </script>

  <style scoped>

  </style>
